import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input } from 'reactstrap';
import ReactOnRails from 'react-on-rails';

class CancelPackageButton extends Component {
  static propTypes = {
    formUrl: PropTypes.string.isRequired,
  };

  state = {
    isModalVisible: false,
    submitDisabled: true
  };

  toggleModal = () => {
    this.setState((last) => ({ isModalVisible: !last.isModalVisible }));
  }

  handleChange = (e) => {
    if (e.target.value == '') {
      this.setState( {submitDisabled: true} )
    }else {
      this.setState( {submitDisabled: false} )
    }
  }

  render() {
    return (
      <div>
        <Button color="danger" onClick={this.toggleModal}>Cancel Package</Button>
        <Modal isOpen={this.state.isModalVisible} toggle={this.toggleModal}>
          <ModalHeader toggle={this.toggleModal}>Cancel Package</ModalHeader>
          <form action={this.props.formUrl} method="POST">
            <input type="hidden" name="authenticity_token" value={ReactOnRails.authenticityToken()} />
            <ModalBody>
              <Input type="textarea" name="reason" placeholder="Why do you want to cancel this package?" onChange={this.handleChange} />
            </ModalBody>
            <ModalFooter>
              <input type="submit" value="Cancel this package" className="btn btn-danger" disabled={this.state.submitDisabled} />
            </ModalFooter>
          </form>
        </Modal>
      </div>
    );
  }
}

export default CancelPackageButton;



// WEBPACK FOOTER //
// app/client/bundles/PageSpecificComponents/CancelPackageButton.jsx